import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blockchain-world',
  templateUrl: './blockchain-world.component.html',
  styleUrls: ['./blockchain-world.component.sass']
})
export class BlockchainWorldComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.querySelector(".__page-root").scrollIntoView(true);
  }

}
